import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { ASSOCIATE_CART_WITH_USER_ERROR, ASSOCIATE_CART_WITH_USER_REQUEST, ASSOCIATE_CART_WITH_USER_SUCCESS } from '../types';
export var associateCartRequest = function associateCartRequest() {
  return {
    type: ASSOCIATE_CART_WITH_USER_REQUEST
  };
};
export var associateCartSuccess = function associateCartSuccess(cart) {
  return {
    type: ASSOCIATE_CART_WITH_USER_SUCCESS,
    data: cart
  };
};
export var associateCartError = function associateCartError(error) {
  return {
    type: ASSOCIATE_CART_WITH_USER_ERROR,
    error: true,
    payload: error
  };
};
export var associateCartWithUser = function associateCartWithUser() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var chord, _getState, auth, cart, newCart;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chord = _ref.chord;
            _getState = getState(), auth = _getState.auth, cart = _getState.cart;
            if (auth.token) {
              _context.next = 4;
              break;
            }
            throw new Error('Cannot associate cart with user, user is not logged in');
          case 4:
            if (cart.data.id) {
              _context.next = 6;
              break;
            }
            throw new Error('Cannot associate cart with user, cart is not found');
          case 6:
            _context.prev = 6;
            dispatch(associateCartRequest());
            _context.next = 10;
            return chord.oms.associateOrderWithUser(cart.data, auth.token);
          case 10:
            newCart = _context.sent;
            dispatch(associateCartSuccess(newCart));
            _context.next = 18;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](6);
            dispatch(associateCartError(_context.t0));
            throw _context.t0;
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[6, 14]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};